<template>
  <modal
    name="hotelmodal"
    :width="width"
    :height="height"
    classes="modalBox"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </modal>
</template>

<script>
import 'vue-js-modal/dist/styles.css'
import { removeFromDom } from '@ota-frontend/core/helpers/element'

export default {
  name: 'TkHotelModal',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  mounted() {
    document.body.classList.add('modalOpen')
    this.$modal.show('hotelmodal')
    // to make sure removing element only after destroying all listeners
    this.$once('hook:destroyed', () => {
      document.body.classList.remove('modalOpen')
      removeFromDom(this.$el)
    })
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/TkHotelModal.scss';
</style>
